angular.module('app.api').factory('MakeMeAnOfferApi', [
  'api',
  function MakeMeAnOfferApi(api) {
    const makeMeAnOfferApi = {
      getCandidateEmployerRecommendations: async (id, payload, candidate) => {
        console.debug('MMO::getCandidateEmployerRecommendations', {
          id,
          payload,
          candidate,
        })
        const result = await api.get(
          `recommendations/candidate/${id}/employer`,
          {
            params: payload,
          }
        )

        console.debug('MMO::result', result)

        return result
      },
    }
    return makeMeAnOfferApi
  },
])



// WEBPACK FOOTER //
// ./scripts/make-me-offer/make-me-an-offer.api.js